const fr = {
  translation: {},
};

export default fr;
